import axios from 'axios'
import { Application } from '../Mappers/ApplicationFormMapper'

interface SubmissionRepositoryResult {
  submit: (application: Application) => Promise<{
    Redirect: string,
    UserAuthToken: string
    PublicReference: string,
    _links: {
      Href: string,
      Rel: string
    }[]
  }>
}

const SubmissionRepository = ({
  submissionURL
}: Record<string, string>): SubmissionRepositoryResult => {
  const submit = async (application: Application) => {
    const result = await axios.post(
      submissionURL,
      application,
      {
        withCredentials: true
      }
    )

    // TODO: What does this `postToOptimizelyService` do?
    // await postToOptimizelyService(result.data.PublicReference);

    return result.data
  }

  return {
    submit
  }
}

export default SubmissionRepository
